import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { Tooltip } from 'components';

const StyledFormSectionTitle = styled.div`
  display: flex;
  align-items: center;
  margin: 2rem 0;
  padding: 0.5rem 0;
  padding-left: 10px;
  border-left: 8px solid ${props => props.color};

  svg {
    margin: 0 1rem;
  }

  p {
    font-size: 18px;
    font-family: 'ArimoBold';
    color: var(--grey-dark-2)
  }
`;

const FormSectionTitle = ({
  title, color, tooltip, testId
}) => (
  <StyledFormSectionTitle color={color}>
    <Typography data-testid={testId}>{title}</Typography>
    {tooltip && <Tooltip label={tooltip} />}
  </StyledFormSectionTitle>
);

FormSectionTitle.propTypes = {
  color: PropTypes.string,
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string
};

FormSectionTitle.defaultProps = {
  color: 'var(--tertiary-color)',
  tooltip: ''
};

export default FormSectionTitle;